/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { Component, OnInit, ChangeDetectionStrategy, EventEmitter, Output } from '@angular/core';

@Component({
	selector: 'completed-selection-prompt',
	templateUrl: './completed-selection-prompt.component.html',
	styles: [],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CompletedSelectionPromptComponent implements OnInit {
	@Output() public unselectCompleted = new EventEmitter();

	constructor() {}
	public ngOnInit() {}

	public unselect() {
		this.unselectCompleted.emit();
	}
}
